var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category"},[_c('el-button',{attrs:{"size":"medium","type":"info"},on:{"click":function($event){_vm.isContentShow = !_vm.isContentShow}}},[_vm._v("主要按钮")]),_c('div',{class:_vm.isContentShow ? 'slot-block' : 'slot-block-active'},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }